
import { Link, useLocation } from "react-router-dom";

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts.map((p, idx) => {
    const href = "/" + parts.slice(0, idx + 1).join("/");
    const label = p.split("-").map(s => s[0]?.toUpperCase() + s.slice(1)).join(" ");
    const nextPart = parts[idx + 1];
    const isNumericSegment = /^\d+$/.test(p);
    const isActionSegment = p === "edit";
    const isIdBeforeEdit = isNumericSegment && nextPart === "edit";
    const clickable = !isActionSegment && !isIdBeforeEdit;
    return { href, label, clickable };
  });
  return (
    <nav className="text-xs text-gray-500">
      <ol className="flex flex-wrap items-center gap-1">
        <li><Link to="/dashboard" className="hover:text-gray-700">Home</Link></li>
        {crumbs.map((c, i) => (
          <li key={c.href} className="flex items-center gap-1">
            <span>/</span>
            {i < crumbs.length - 1 && c.clickable ? (
              <Link to={c.href} className="hover:text-gray-700">{c.label}</Link>
            ) : <span className="text-gray-700">{c.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
